import { apiService } from '../../../core/services/api';
import {
  Company,
  AdminUser,
  CreateUserRequest,
  UpdateUserRequest,
  SystemSettings,
  UsersFilters,
  LogsFilters,
  UsersResponse,
  LogsResponse,
} from '../types';

export const adminService = {
  // Company Management
  getCompany: async (): Promise<Company> => {
    return apiService.get<Company>('/admin/company');
  },

  updateCompany: async (companyData: Partial<Company>): Promise<Company> => {
    return apiService.put<Company>('/admin/company', companyData);
  },

  // User Management
  getUsers: async (filters?: UsersFilters): Promise<UsersResponse> => {
    return apiService.get<UsersResponse>('/admin/users', { params: filters });
  },

  createUser: async (userData: CreateUserRequest): Promise<{ message: string; user: AdminUser }> => {
    return apiService.post<{ message: string; user: AdminUser }>('/admin/users', userData);
  },

  updateUser: async (id: string, userData: UpdateUserRequest): Promise<{ message: string; user: AdminUser }> => {
    return apiService.put<{ message: string; user: AdminUser }>(`/admin/users/${id}`, userData);
  },

  deleteUser: async (id: string): Promise<{ message: string }> => {
    return apiService.delete<{ message: string }>(`/admin/users/${id}`);
  },

  // System Settings
  getSettings: async (): Promise<SystemSettings> => {
    return apiService.get<SystemSettings>('/admin/settings');
  },

  updateSettings: async (settingsData: Partial<SystemSettings>): Promise<SystemSettings> => {
    return apiService.put<SystemSettings>('/admin/settings', settingsData);
  },

  // System Logs
  getLogs: async (filters?: LogsFilters): Promise<LogsResponse> => {
    return apiService.get<LogsResponse>('/admin/logs', { params: filters });
  },
}; 